export default __webpack_public_path__ + "static/media/MDX-USDT.065dd03f.png";